
import u from "umbrellajs"
import _once from "lodash/once"
import _mapValues from "lodash/mapValues"

const get$Html = _once(() => u("html"))

const isIE  = () => get$Html().hasClass("browser-ie")
const isIE6 = () => get$Html().hasClass("browser-ie-6")
const isIE7 = () => get$Html().hasClass("browser-ie-7")
const isIE8 = () => get$Html().hasClass("browser-ie-8")
const isIE9 = () => get$Html().hasClass("browser-ie-9")

const isIE8OrLess = () => [isIE8, isIE7, isIE6].some((func) => func())
const isIE9OrLess = () => [isIE8OrLess, isIE9].some((func) => func())

const BrowserDetection = _mapValues({
  isIE,
  isIE6,
  isIE7,
  isIE8,
  isIE9,
  isIE8OrLess,
  isIE9OrLess,
}, (func) => _once(func))

export default BrowserDetection

export {
  isIE9OrLess,
}
